import { isNotNull } from "utils/types/typeguards";
import { FooterColumnItem, FooterColumnType } from "utils/types/util.types";
import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
	column: FooterColumnType
};

function FooterColumn({
	column: {
		id,
		columnItems,
	},
}: Props) {

	const { t } = useTranslation();

	const getLinkText = (columnItem: FooterColumnItem): string => {
		if (isNotNull(columnItem.text)) return columnItem.text;
		if (id === "pages") return t(`pages.${ columnItem.id }`)
		if (id === "products") return t(`products.${ columnItem.id }.title`);
		return "Brak tłumaczenia";
	}

	return (
		<div className="flex flex-col gap-2 text-white">
			<div className="text-2xl xs:text-lg font-bold">
				{ t(`footer.columnNames.${ id }`) }
			</div>
			<div className="flex flex-col gap-2">
				{
					columnItems.map((columnItem, index) =>
						<div className="flex gap-2 items-center" key={ index }>
							{ isNotNull(columnItem.image) && <img src={ columnItem.image } alt={ columnItem.text }/> }
							<NavLink to={ columnItem.link } className="text-lg xs:text-base font-normal header-link">
								{ getLinkText(columnItem) }
							</NavLink>
						</div>
					)
				}
			</div>
		</div>
	);
}

export default FooterColumn;